import Vue from 'vue';
import store from './../../store';
import moment from 'moment';

const success = (response, context) => {
    context.rentals = response.data.rentals;
    context.uninitialized_count = response.data.uninitialized_count;
    context.loading = false;
    context.user = response.data.user;

  context.rentals.map((rental) => {
    const checkinStartTime = rental.checkin.split(':');
    const checkinEndTime = rental.checkin_end.split(':');
    const checkoutEndTime = rental.checkout.split(':');

    rental.checkinStart = {
      HH: moment(checkinStartTime[0], 'kk:mm').format('HH'),
      mm: checkinStartTime[1],
    };
    rental.checkinTo = {
      HH: moment(checkinEndTime[0], 'kk:mm').format('HH'),
      mm: checkinEndTime[1],
    };
    rental.checkoutEnd = {
      HH: moment(checkoutEndTime[0], 'kk:mm').format('HH'),
      mm: checkoutEndTime[1],
    };
  });
};

const failed = (error, context) => {
  // toastr.error(error.data.msg);
};

export default context => Vue.$http.get('/rentals')
        .then((response) => {
          if (response && response.status === 200) {
            success(response, context);
          }
        })
    .catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/rental/get.js